import { useQuery } from "@tanstack/react-query"

import { SetupRequests } from "@costory/types/endpoints/setup"

import { apiClient } from "@costory/front/lib/apiClient"

export const useSetupQuery = (data: SetupRequests.Setup) => {
  return useQuery({
    queryFn: async () => {
      const response = await apiClient.post("/setup/ask-for-setup", data)
      return response.data
    },
    queryKey: ["setup", data],
  })
}
